import { Cropper } from "react-cropper";
import { useRef } from "react";
import Header from "../../../../components/header/header";
import { CompleteBtn } from "../../../../components/header/btn/complete-btn";
import { BackBtn } from "../../../../components/header/btn/back-btn";
import "cropperjs/dist/cropper.css";

export const ImageCropper = ({ imagePath, setCroppedImage, close }) => {
    const cropperRef = useRef(null);
    const cropAndClose = () => {
        const cropper = cropperRef.current.cropper;
        const url = cropper.getCroppedCanvas().toDataURL()

        cropper.getCroppedCanvas().toBlob((blob) => {
            setCroppedImage(url, blob);
            close()
        }, 'image/jpeg', 1)
    };

    const rotate = () => {
        const cropper = cropperRef.current.cropper;
        cropper.rotate(90)
    }

    return (
        <div className="img-cropper-container">
            <Header>
                <BackBtn position={"left"} onClick={close} />
                <CompleteBtn position={"right"} onClick={cropAndClose} />
            </Header>
            <div className={"img-cropper-content"}>
                <div className="img-cropper-wrapper">
                    <Cropper className={"cropper"}
                        ref={cropperRef}
                        src={imagePath}
                        initialAspectRatio={1}
                        viewMode={3}
                        preview=".img-preview"
                        background={false}
                        center={true}
                        zoomable={true}
                        movable={true}
                        cropBoxMovable={false}
                        cropBoxResizable={false}
                        autoCropArea={1}
                        checkOrientation={false}
                        dragMode={'move'}
                        guides={false}
                    />
                </div>
                <div className="img-cropper-btn">
                    <div className="btn-wrapper">
                        <img src="/assets/icons/rotate-right.svg" />
                        <button onClick={rotate}>회전</button>
                    </div>
                </div>
            </div>
        </div>
    )
}